import { HttpError } from '../models';
import { AppStoreModule } from '../../store';
import errorMessages from './errorMessages.json';

const genericServerError = 'An error occurred while making a request to the API.';

export class ErrorHelper {
  static getHttpErrors(httpError: any): HttpError {
    let errorCodes: string[] = [];
    if (httpError.response.data) {
      const serverErrors = httpError.response.data;
      serverErrors.forEach((serverError: any) => {
        // we only save error codes from Api. Corresponding messages need to come from content writer.
        errorCodes.push(serverError.Code);
      });
    } else {
      if (httpError.response.status === 403) {
        errorCodes = ['Forbidden'];
      } else {
        errorCodes = ['ServerError'];
      }
    }
    return new HttpError(httpError.response.status, errorCodes);
  }

  static getHttpErrorMessage(errorCode: string) {
    const message = errorMessages.find((msg) => msg.statusCode === errorCode);
    if (message) {
      return message.message;
    } else {
      return genericServerError;
    }
  }

  static getMessageForError(error: any, defaultMessage?: string) {
    if (error instanceof HttpError) {
      return error.message;
    } else {
      return defaultMessage || genericServerError;
    }
  }

  static handleError(message: string) {
    AppStoreModule.handleHttpError( message || genericServerError);
  }

  static clearError() {
    AppStoreModule.clearHttpError();
  }
}
